import { Injectable } from '@angular/core';
import { ConsultaRESTBaseService } from './consulta-restbase.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertMessageService } from '@sigepe/sigepe-template';
import { ParametrosFeriasCargo, ParametrosFeriasOrgao } from './vinculos.service';
import { PeriodoAquisitivo } from 'src/app/components/shared/models/periodo-aquisitivo';

export interface FiltroObterExercicios {
    codigoOrgao: number;
    matricula: number;
}

export interface Exercicios {
    id: number;
    ano: number;
    dataInicioPeriodoAquisitivo: string;
    dataFimPeriodoAquisitivo: string;
    dataInicioPeriodoProgramacao: string;
    dataFimPeriodoProgramacao: string;
    quantidadeDias: number;
    situacao: string;
    parcelas: ParcelaFerias[];
    sucessoEnvioMensageria: boolean;
    justificativaPerdaDireito: string;
    periodoAquisitivo: string;
    quantidadeMaximaParcelas?: number;
    tipoFeriasEspecial?: string;
    descricaoTipoFeriasEspecial?: string;
    acoesFeriasEspeciais?: string[];
    extraordinario?: boolean;
    sentencaJudicial?: string;
}

export interface ExercicioSelecionado {
    idFerias: number;
    cpf: string;
    nome: string;
    chefiaImediata: string;
    vinculoEmExercicio: string;
    orgaoEmExercicio: string;
    codigoSituacaoFuncional: number;
    regime: string;
    siglaRegime: string;
    anoExercicio: number;
    saldoDias: number;
    situacaoExercicio: string;
    dataInicioPeriodoAquisitivo: string;
    dataFimPeriodoAquisitivo: string;
    dataInicioPeriodoProgramacao: string;
    dataFimPeriodoProgramacao: string;
    dataInicioPeriodoProgramacaoDisponivel: string;
    dataFimPeriodoProgramacaoDisponivel: string;
    parcelas: ParcelaFerias[];
    raioX: boolean;
    parametrosFeriasOrgao: ParametrosFeriasOrgao;
    parametrosFeriasCargo: ParametrosFeriasCargo;
    justificativaPerdaDireito: string;
    periodoAquisitivo: string;
    quantidadeMaximaParcelas?: number;
    tipoFeriasEspecial?: string;
    descricaoTipoFeriasEspecial?: string;
    extraordinario?: boolean;
    sentencaJudicial?: string;
}

export interface ParcelaFerias {
    id: number;
    idParcelaPai?: number;
    ordem: number;
    parcelaFilha?: ParcelaFerias;
    dataInicio: Date;
    dataFim?: Date;
    quantidadeDias: number;
    adiantamentoSalarial: boolean;
    abonoPecuniario: boolean;
    adiantamentoDecimoTerceiro: boolean;
    parcelasDesconto?: number;
    emAcumulo?: boolean;
    situacao?: string;
    justificativaAcumulo?: string;
    dataInterrupcao?: Date;
    documentoLegal?: number;
    dataPublicacaoDocumentoLegal?: Date;
    motivoLegal?: string;
    justificativaInterrupcao?: string;
}

export interface ParcelaInterrompidaFerias {
    id: number;
    idParcelaPai: number;
    ordem: number;
    dataInicio: Date;
    dataFim: Date;
    quantidadeDias: number;
    situacao: string;
    adiantamentoSalarial: boolean;
    parcelasDesconto: number;
    abonoPecuniario: boolean;
    adiantamentoDecimoTerceiro: boolean;
    emAcumulo?: boolean;
    motivoLegal: string;
    dataInterrupcao: Date;
    justificativaInterrupcao: string;
    documentoLegal: string;
    dataPublicacaoDocumentoLegal: Date;
    justificativaAcumulo?: string;
}

export interface CancelamentoParcelaInterrompidaFerias {
    id: number;
    idParcelaPai: number;
    ordem: number;
    dataInicio: Date;
    dataFim: Date;
    quantidadeDias: number;
    situacao: string;
    adiantamentoSalarial: boolean;
    abonoPecuniario: boolean;
    adiantamentoDecimoTerceiro: boolean;
    emAcumulo?: boolean;
    motivoLegal: string;
    dataInterrupcao: Date;
    justificativaInterrupcao: string;
    documentoLegal: string;
    dataPublicacaoDocumentoLegal: Date;
    justificativaCancelamentoInterrupcao: string;
}

export interface ProgramarFerias {
    parcelas: ParcelaFerias[];
    justificativaParaAgendarFerias: string;
}

export interface FeriasEspeciaisAdministrativas {
    numeroProcesso: string;
    quantidadeDias: number;
    justificativa: string;
}

export interface FeriasEspeciaisJudiciais {
    numeroProcesso: string;
    sentencaJudicial: string;
    quantidadeDias: number;
    quantidadeMaximaParcelas: number;
    periodoAquisitivo: string;
    extraordinario: boolean;
    dataFimPeriodoProgramacao?: string;
    declaracaoAcaoJudicial: boolean;
}

export interface ParcelaFeriasEspecialComParcelas {
    id?: number;
    idParcelaPai?: number;
    ordem: number;
    dataInicio: string;
    quantidadeDias: number;
    adiantamentoSalarial: boolean;
    abonoPecuniario: boolean;
    adiantamentoDecimoTerceiro: boolean;
    parcelasDesconto?: number;
    dataInterrupcao?: Date;
    motivoLegal?: string;
    justificativaInterrupcao?: string;
    documentoLegal?: string;
    dataPublicacaoDocumentoLegal?: Date;
}

export interface ParcelaFeriasEspecialAdministrativaComParcelas extends ParcelaFeriasEspecialComParcelas {
    geracao: number;
    idTemporario?: string;
    idTemporarioParcelaPai?: string;
}

export interface FeriasEspeciaisAdministrativasComParcelas {
    numeroProcesso: string;
    quantidadeDias: number;
    justificativa: string;
    periodoAquisitivo: PeriodoAquisitivo;
    extraordinario: boolean;
    dataInicioPeriodoAquisitivo?: string;
    dataFimPeriodoProgramacao?: string;
    parcelas: ParcelaFeriasEspecialAdministrativaComParcelas[];
}

export interface ParcelaFeriasEspecialJudicialComParcelas extends ParcelaFeriasEspecialComParcelas {
    geracao: number;
    idTemporario?: string;
    idTemporarioParcelaPai?: string;
}

export interface FeriasEspeciaisJudiciaisComParcelas {
    numeroProcesso: string;
    sentencaJudicial: string;
    quantidadeDias: number;
    quantidadeMaximaParcelas: number;
    periodoAquisitivo: PeriodoAquisitivo;
    extraordinario: boolean;
    declaracaoAcaoJudicial: boolean;
    dataFimPeriodoProgramacao?: string;
    parcelas: ParcelaFeriasEspecialJudicialComParcelas[];
}

export interface OperacaoFeriasEspeciaisDetalhada {
    transacao?: string;
    numeroProcesso?: string;
    fundamentacao?: string;
    cpfResponsavel?: number;
    dataOperacao?: string;
    revisao?: number;
}

export interface ParcelaDetalhadaFeriasEspeciais {
    id?: number;
    ordem?: number;
    dataInicio?: string;
    dataFim?: string;
    quantidadeDias?: number;
    situacao?: string;
    ativa?: boolean;
    abonoPecuniario?: boolean;
    adiantamentoSalarial?: boolean;
    adiantamentoDecimoTerceiro?: boolean;
    parcelasDesconto?: number;
}

export interface ExercicioDetalhadoFeriasEspeciais {
    anoExercicio?: number;
    situacao?: string;
    quantidadeDias?: number;
    quantidadeMaximaParcelas?: number;
    extraordinario?: boolean;
    dataInicioPeriodoAquisitivo?: string;
    dataFimPeriodoAquisitivo?: string;
    tipoPeriodoAquisitivo?: PeriodoAquisitivo;
    dataInicioPeriodoProgramacao?: string;
    dataFimPeriodoProgramacao?: string;
    parcelas?: ParcelaDetalhadaFeriasEspeciais[];
}

export interface DiferencaFeriasEspeciais {
    campo: string;
    valorOriginal?: string;
    valorAtual?: string;
}

/**
 * Resposta dos detalhamentos de férias especiais, com ou sem parcelas.
 *
 * Quando `historicoDisponivel` é `false`, `exercicioOriginal` vem nulo e `diferencas` vazio:
 * o estado atual nunca substitui o original.
 */
export interface DetalhamentoFeriasEspeciais {
    idFerias: number;
    modalidade?: string;
    descricaoModalidade?: string;
    historicoDisponivel: boolean;
    motivoIndisponibilidadeHistorico?: string;
    operacao?: OperacaoFeriasEspeciaisDetalhada | null;
    exercicioAtual?: ExercicioDetalhadoFeriasEspeciais;
    exercicioOriginal?: ExercicioDetalhadoFeriasEspeciais;
    diferencas?: DiferencaFeriasEspeciais[];
}

export interface FeriasDTO {
    id: number;
    quantidadeDias: number;
    quantidadeMaximaParcelas?: number;
    tipoFeriasEspecial?: 'ASP' | 'JSP' | 'ACP' | 'JCP';
    extraordinario?: boolean;
    periodoAquisitivo?: string;
    dataFimPeriodoProgramacao?: string;
    sentencaJudicial?: string;
    parcelas?: ParcelaFerias[];
}

export interface PeriodoProgramacaoFeriasDTO {
    dataInicioPeriodoProgramacao: string;
    dataFimPeriodoProgramacao: string;
}

@Injectable({
    providedIn: 'root'
})
export class ExerciciosService extends ConsultaRESTBaseService {
    constructor(alertaMsgService: AlertMessageService, http: HttpClient) {
        super(alertaMsgService, http);
    }

    public programarFerias(idExercicio: number, parcelas: ProgramarFerias): Observable<Exercicios> {
        return super.post(`/ferias/${idExercicio}/parcelas`, parcelas);
    }

    public reprogramarFerias(idExercicio: number, parcelas: ParcelaFerias[]): Observable<Exercicios> {
        return super.put(`/ferias/${idExercicio}/parcelas`, parcelas);
    }

    public homologarFerias(idExercicio: number, parcelas: ParcelaFerias[]): Observable<Exercicios> {
        return super.put(`/ferias/${idExercicio}/parcelas-homologadas`, parcelas);
    }

    public recusarFerias(idExercicio: number, parcelas: ParcelaFerias[]): Observable<Exercicios> {
        return super.put(`/ferias/${idExercicio}/parcelas-recusadas`, parcelas);
    }

    public interromperFerias(idExercicio: number, parcelas: ParcelaInterrompidaFerias[]): Observable<Exercicios> {
        return super.put(`/ferias/${idExercicio}/parcelas-interrompidas`, parcelas);
    }

    public cancelarInterrupcaoFerias(idExercicio: number, parcelas: CancelamentoParcelaInterrompidaFerias[]): Observable<Exercicios> {
        return super.put(`/ferias/${idExercicio}/cancelar-parcelas-interrompidas`, parcelas);
    }

    public feriasEspeciaisAdministrativas(idExercicio: number, dados: FeriasEspeciaisAdministrativas): Observable<FeriasDTO> {
        return super.put(`/ferias-especiais/${idExercicio}/administrativa`, dados);
    }

    public feriasEspeciaisJudiciais(idExercicio: number, dados: FeriasEspeciaisJudiciais): Observable<FeriasDTO> {
        return super.put(`/ferias-especiais/${idExercicio}/judicial`, dados);
    }

    public obterPeriodoProgramacaoFeriasEspeciais(idExercicio: number, periodoAquisitivo: PeriodoAquisitivo, comParcelas: boolean): Observable<PeriodoProgramacaoFeriasDTO> {
        return super.get(`/ferias-especiais/${idExercicio}/periodo-programacao?periodoAquisitivo=${periodoAquisitivo}&comParcelas=${comParcelas}`);
    }

    public feriasEspeciaisAdministrativasComParcelas(idExercicio: number, dados: FeriasEspeciaisAdministrativasComParcelas): Observable<FeriasDTO> {
        return super.put(`/ferias-especiais/${idExercicio}/administrativa/com-parcelas`, dados);
    }

    public feriasEspeciaisJudiciaisComParcelas(idExercicio: number, dados: FeriasEspeciaisJudiciaisComParcelas): Observable<FeriasDTO> {
        return super.put(`/ferias-especiais/${idExercicio}/judicial/com-parcelas`, dados);
    }

    public detalharFeriasEspeciaisComParcelas(idExercicio: number): Observable<DetalhamentoFeriasEspeciais> {
        return super.get(`/ferias-especiais/${idExercicio}/detalhamento/com-parcelas`);
    }

    public detalharFeriasEspeciaisSemParcelas(idExercicio: number): Observable<DetalhamentoFeriasEspeciais> {
        return super.get(`/ferias-especiais/${idExercicio}/detalhamento/sem-parcelas`);
    }

    public enviarHomologacaoParaFolha(idFerias): Observable<Exercicios> {
        return super.post(`/folha-pagamento-servicos/enviar-homologacao-para-folha/${idFerias}`, null);
    }
}
